module.exports = __webpack_public_path__ + "static/media/partner-hero.6a18e748.png";